/*
  Quick JS by Jason @ freakdesign.
  Questions? Ping me on twitter: @freakdesign
  Relates to blog post:
  https://freakdesign.com.au/blogs/news/get-shipping-estimates-on-a-product-page
  Example:
  https://jasons-experiments.myshopify.com/products/alex-twill-pant-mariner
*/
(function () {

    "use strict";

    /* In case you want to output a bunch of things to the debug console */
    var debug = false;
    var cartCookie;

    function log(text) {
        console.log(text);
    }

    /* The ID of the element that you want to add the shipping fields into */
    var productSection = document.getElementsByClassName('frete-produto');
    if (!productSection.length) { log('Could not find the element'); return }

    /* the main product select element */
    var productSelect = document.getElementById('ProductSelect-product-template');
    if (!productSelect) { productSelect = document.getElementsByName('id')[0]; }
    if (!productSelect) { log('Could not find the main select element'); return }

    /* create a message box */
    var shippingMessage = document.createElement('p');
    var shippingCountry = document.createElement('select');
    var shippingProvince = document.createElement('select');
    var shippingZip = document.createElement('input');
    var freteLista = document.createElement('div');

    /* Erro Frete */
    shippingMessage.classList.add('erros-fretes');
    shippingMessage.setAttribute("style", "display:none");

    /* Ajustes da lista de fretes */
    freteLista.classList.add('listas-de-fretes');
    freteLista.setAttribute("style", "display:none");

    /* ADAPTACAO 1 — mascara de CEP sem dependencia externa.
       O original chamava $(campo).mask("00.000-000"), do plugin jQuery Mask, que nao existe
       neste tema (conferido em assets/, em vendor.js e em theme.js). Como a chamada acontece
       na inicializacao, a ausencia do plugin derrubava o script inteiro antes de desenhar o
       campo. Esta funcao formata enquanto digita e preserva a posicao do cursor no fim. */
    var aplicaMascaraCep = function (campo) {
        var formata = function () {
            var so = campo.value.replace(/\D/g, '').slice(0, 8);
            var saida = so;
            if (so.length > 5) {
                saida = so.slice(0, 2) + '.' + so.slice(2, 5) + '-' + so.slice(5);
            } else if (so.length > 2) {
                saida = so.slice(0, 2) + '.' + so.slice(2);
            }
            campo.value = saida;
        };
        campo.addEventListener('input', formata);
        campo.setAttribute('inputmode', 'numeric');
        campo.setAttribute('maxlength', '10');
    };

    /* ADAPTACAO 2 — quantidade real da buybox.
       O original lia #Quantity, que so existe no tema antigo; na buybox do redesign a
       quantidade mora em [data-oatz-qty-value] (produto simples) ou somada entre as linhas
       de [data-oatz-flavor-qty-value] (produto com varios sabores). Sem isto o frete era
       sempre cotado para 1 unidade, independente do que a pessoa escolhesse. */
    var quantidadeEscolhida = function () {
        /* Monte seu kit: o total já vem somado na barra do pedido. */
        var totalKit = document.querySelector('[data-kb-un]');
        if (totalKit && parseInt(totalKit.textContent, 10) > 0) return parseInt(totalKit.textContent, 10);
        var linhas = document.querySelectorAll('[data-oatz-flavor-qty-value]');
        if (linhas.length) {
            var soma = 0;
            Array.prototype.forEach.call(linhas, function (el) {
                soma += parseInt(el.textContent, 10) || 0;
            });
            if (soma > 0) return soma;
        }
        var campoOatz = document.querySelector('[data-oatz-buybox-qtyinput]');
        if (campoOatz && parseInt(campoOatz.value, 10) > 0) return parseInt(campoOatz.value, 10);
        var valorOatz = document.querySelector('[data-oatz-qty-value]');
        if (valorOatz && parseInt(valorOatz.textContent, 10) > 0) return parseInt(valorOatz.textContent, 10);
        var antigo = document.getElementById('Quantity');
        return antigo ? (parseInt(antigo.value, 10) || 1) : 1;
    };

    /* We are just adding some dummy fields for example only. There's better ways to handle this */
    var initFields = function () {

        /* create the country picker */
        shippingCountry.id = "pais-simulator";

        var countries = ['Brazil'];
        for (var i = 0; i < countries.length; i++) {
            shippingCountry.add(new Option(countries[i], countries[i], i === 0));
        };
        shippingCountry.name = 'shipping_address[country]';

        /* create the province state picker */
        shippingProvince.id = "estados-simulator";

        var provinces = ['Acre', 'Alagoas', 'Amapa', 'Amazonas', 'Bahia', 'Ceara', 'Distrito Federal', 'Espirito Santo', 'Goias', 'Maranhao', 'Mato Grosso', 'Mato Grosso do Sul', 'Minas Gerais', 'Para', 'Paraiba', 'Parana', 'Pernambuco', 'Piaui', 'Rio de Janeiro', 'Rio Grande do Norte', 'Rio Grande do Sul', 'Rondonia', 'Roraima', 'Santa Catarina', 'Sao Paulo', 'Sergipe', 'Tocantins'];
        for (var i = 0; i < provinces.length; i++) {
            shippingProvince.add(new Option(provinces[i], provinces[i], i === 0));
        };
        shippingProvince.name = 'shipping_address[province]';

        /* create the zip / postcode field */
        shippingZip.type = 'text';
        shippingZip.name = 'shipping_address[zip]';
        shippingZip.className = 'Form__Input cep-calculo-frete form-control';
        shippingZip.placeholder = 'DIGITE SEU CEP';
        aplicaMascaraCep(shippingZip);

        /* create a wrapper for the fields */
        var shippingCalcWrapper = document.createElement('div');
        shippingCalcWrapper.className = 'shipping-calc-wrapper';

        /* create a wrapper for the fields */
        var formularioFrete = document.createElement('div');
        formularioFrete.className = 'formulario-frete';

        /* create a title */
        var shippingCalcTitle = document.createElement('p');
        shippingCalcTitle.innerText = 'Simule seu frete';

        /* create a get rates button */
        var shippingCalcButton = document.createElement('a');
        shippingCalcButton.innerText = 'Calcular';
        shippingCalcButton.className = 'btn btn-underline button--primary button';
        shippingCalcButton.onclick = function () {

            var cepLimpo = shippingZip.value.replace(/\D/g, '');

            shippingMessage.innerHTML = '';
            shippingMessage.setAttribute("style", "display:none");

            if (cepLimpo.length !== 8) {
                $('.listas-de-fretes').html("");
                shippingMessage.innerHTML = 'Digite seu CEP para calcular o frete.';
                shippingMessage.setAttribute("style", "display:flex");
                return false;
            }
            /* CORRECAO 1 — kit vazio: avisa em vez de nao fazer nada. */
            var itensCotacao = itensParaCotar();
            if (!itensCotacao.length) {
                $('.listas-de-fretes').html("").hide();
                shippingMessage.innerHTML = 'Escolha seus sabores para calcular o frete';
                shippingMessage.setAttribute("style", "display:flex");
                return false;
            }
            if (calculando) { return false; }
            $.getJSON("https://viacep.com.br/ws/" + cepLimpo + "/json/?callback=?", function (dados) {
                if (!("erro" in dados)) {
                    shippingProvince.value = UF[dados.uf] || shippingProvince.value;
                    getRates(itensCotacao, cepLimpo);
                } else {
                    mostraErro('Cep não encontrado, tente novamente.');
                }
            }).fail(function () {
                mostraErro('Cep não encontrado, tente novamente.');
            });
            return false;
        };

        /* CORRECAO 2 — Enter no campo de CEP tambem calcula. */
        shippingZip.addEventListener('keydown', function (e) {
            if (e.key === 'Enter' || e.keyCode === 13) {
                e.preventDefault();
                shippingCalcButton.onclick();
            }
        });

        /* create some labels for the fields */
        var labelNames = ['País', 'Estado', 'CEP'];
        var labels = [];
        for (var i = 0; i < labelNames.length; i++) {
            var label = document.createElement('label');
            label.innerText = labelNames[i];
            labels.push(label);
        };

        shippingCalcWrapper.appendChild(formularioFrete);

        /*shippingCalcWrapper.appendChild(shippingCalcTitle);
            shippingCalcWrapper.appendChild(labels[0]);*/
        formularioFrete.appendChild(shippingCountry);
        /*shippingCalcWrapper.appendChild(labels[1]);*/
        formularioFrete.appendChild(shippingProvince);
        /*shippingCalcWrapper.appendChild(labels[2]);*/
        formularioFrete.appendChild(shippingZip);
        formularioFrete.appendChild(shippingCalcButton);
        shippingCalcWrapper.appendChild(shippingMessage);
        shippingCalcWrapper.appendChild(freteLista);

        /* add to the page */
        productSection[0].appendChild(shippingCalcWrapper);

    };

    /* A console logging function */
    var log = function (a) {
        if (!debug) { return }
        console.log(a);
    };

    var calculando = false;
    var UF = { AC: 'Acre', AL: 'Alagoas', AP: 'Amapa', AM: 'Amazonas', BA: 'Bahia', CE: 'Ceara', DF: 'Distrito Federal', ES: 'Espirito Santo', GO: 'Goias', MA: 'Maranhao', MT: 'Mato Grosso', MS: 'Mato Grosso do Sul', MG: 'Minas Gerais', PA: 'Para', PB: 'Paraiba', PR: 'Parana', PE: 'Pernambuco', PI: 'Piaui', RJ: 'Rio de Janeiro', RN: 'Rio Grande do Norte', RS: 'Rio Grande do Sul', RO: 'Rondonia', RR: 'Roraima', SC: 'Santa Catarina', SP: 'Sao Paulo', SE: 'Sergipe', TO: 'Tocantins' };

    var mostraErro = function (msg) {
        $('.listas-de-fretes').html("").hide();
        shippingMessage.innerHTML = msg;
        shippingMessage.setAttribute("style", "display:flex");
    };

    /* CORRECAO 3 — BRL com virgula e centavos ("R$ 21,86"); 0 vira "Frete grátis".
       O original passava o preco em reais ("21.86") para formatMoney, que espera centavos,
       com o formato amount_no_decimals: o resultado saia arredondado ("R$ 22"). */
    var formataFrete = function (preco) {
        var v = parseFloat(preco);
        if (preco == null || isNaN(v) || v <= 0) return 'Frete grátis';
        return 'R$ ' + v.toFixed(2).replace('.', ',').replace(/\B(?=(\d{3})+(?!\d))/g, '.');
    };

    /* CORRECAO 4 — cotar os itens de verdade.
       Monte seu Kit: cada sabor escolhido ([data-kb-item] com data-vid e [data-kb-n]).
       PDP: variante selecionada x quantidade da buybox (comportamento antigo). */
    var itensParaCotar = function () {
        var kit = document.querySelectorAll('[data-kb-item]');
        if (kit.length) {
            var lista = [];
            Array.prototype.forEach.call(kit, function (li) {
                var n = parseInt((li.querySelector('[data-kb-n]') || {}).textContent, 10) || 0;
                var vid = parseInt(li.dataset.vid, 10);
                if (n > 0 && vid) lista.push({ id: vid, quantity: n });
            });
            return lista;
        }
        var vid = parseInt(productSelect.value, 10);
        if (!vid) {
            var op = $(productSelect).find('option').get(1);
            vid = op ? parseInt(op.value, 10) : 0;
        }
        return vid ? [{ id: vid, quantity: quantidadeEscolhida() }] : [];
    };

    var jsonFetch = function (url, opts) {
        opts = opts || {};
        opts.credentials = 'same-origin';
        opts.headers = { 'Content-Type': 'application/json', 'X-Requested-With': 'xmlhttprequest' };
        return fetch(url, opts);
    };

    /* CORRECAO 5 — fluxo oficial e assincrono do Shopify:
       POST /cart/prepare_shipping_rates.json e depois consulta /cart/async_shipping_rates.json
       ate vir a resposta (202 = ainda calculando). O original usava o GET sincrono, que
       devolve resultado em cache ou vazio quando a Frenet demora — dai a lista "fixa" e as
       vezes nenhuma lista acima de R$199. */
    var buscaTarifas = function (zip) {
        var q = 'shipping_address%5Bcountry%5D=Brazil' +
            '&shipping_address%5Bprovince%5D=' + encodeURIComponent(shippingProvince.value) +
            '&shipping_address%5Bzip%5D=' + encodeURIComponent(zip);
        return jsonFetch('/cart/prepare_shipping_rates.json?' + q, { method: 'POST' }).then(function (r) {
            if (!r.ok) throw new Error('prepare');
            var tentativas = 0;
            var consulta = function () {
                return jsonFetch('/cart/async_shipping_rates.json?' + q, { method: 'GET' }).then(function (r2) {
                    if (r2.status === 200) return r2.json();
                    if (r2.status === 202 && tentativas++ < 20) {
                        return new Promise(function (ok) { setTimeout(ok, 600); }).then(consulta);
                    }
                    throw new Error('rates ' + r2.status);
                });
            };
            return consulta();
        });
    };

    /* CORRECAO 6 — nao deixar a simulacao no carrinho.
       As tarifas so existem para o carrinho real, entao os itens precisam entrar nele por
       alguns segundos. Antes, guardamos as quantidades que a pessoa ja tinha dessas variantes;
       depois da cotacao (dando certo ou nao), voltamos exatamente para elas com /cart/update.js.
       O truque antigo de trocar o cookie "cart" nao funciona com os carrinhos atuais do
       Shopify, por isso os itens ficavam no carrinho de verdade. */
    var getRates = function (itens, zip) {
        calculando = true;
        shippingMessage.setAttribute("style", "display:none");
        $('.listas-de-fretes').show().html("<img id='loading-icon-frete' src='https://cdn.shopify.com/s/files/1/2184/2809/files/loading-buffering.gif?v=1621716543' width='30px' style='width:30px; height: 30px; margin:0 auto'>");

        var antes = {};
        var restaura = function () {
            var updates = {};
            itens.forEach(function (it) { updates[it.id] = antes[it.id] || 0; });
            return jsonFetch('/cart/update.js?_easygift_internal=true', { method: 'POST', body: JSON.stringify({ updates: updates }) })
                .catch(function () { /* se falhar, os itens ficam no carrinho; nada quebra */ });
        };

        jsonFetch('/cart.js', { method: 'GET' }).then(function (r) { return r.json(); }).then(function (cart) {
            (cart.items || []).forEach(function (l) {
                if (!l.selling_plan_allocation && (!l.properties || !Object.keys(l.properties).length)) {
                    antes[l.variant_id] = (antes[l.variant_id] || 0) + l.quantity;
                }
            });
            return jsonFetch('/cart/add.js?_easygift_internal=true', { method: 'POST', body: JSON.stringify({ items: itens }) });
        }).then(function (r) {
            if (!r.ok) throw new Error('add');
            return buscaTarifas(zip);
        }).then(function (d) {
            var lista = (d && d.shipping_rates) || [];
            $('.listas-de-fretes').html("");
            if (!lista.length) { mostraErro('Não encontramos frete para este CEP. Confira e tente de novo.'); return; }
            lista.forEach(function (t) {
                var entrega = '';
                if (t.delivery_date) {
                    var dt = new Date(t.delivery_date);
                    if (new Date(dt.toDateString()) >= new Date(new Date().toDateString())) {
                        entrega = '(Estimativa de entrega: ' + dt.getDate() + '/' + (dt.getMonth() + 1) + '/' + dt.getFullYear() + ')';
                    }
                }
                var nome = $('<b>').text(t.name).prop('outerHTML');
                $('<div class="frete-item"> <div> <p class="m-0 nome-frete">' + nome + ' <span class="estimativa-de-entrega">' + entrega + '</span></p> </div><div class="frete-valor">Valor: <b> ' + formataFrete(t.price) + '</b></div> </div>').appendTo('.listas-de-fretes');
            });
        }).catch(function (err) {
            log(err);
            mostraErro('Não conseguimos calcular agora. Tente novamente em instantes.');
        }).then(function () {
            return restaura();
        }).then(function () {
            calculando = false;
        });
    };

    initFields();
})();
